import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { searchFootballEntities } from "../services/search.service";

export const useSearchFootballEntities = ({
  limit,
  offset,
  search,
}: {
  limit?: number;
  offset?: number;
  search?: string;
}) => {
  const { i18n } = useTranslation();
  const {
    data: searchFootballEntitiesData,
    isLoading: isSearchFootballEntitiesLoading,
    isError: isSearchFootballEntitiesError,
  } = useQuery({
    queryKey: ["searchFootballEntities", limit, offset, search, i18n.language],
    queryFn: () => searchFootballEntities({ limit, offset, search }),
  });

  // Handle response structure: { items: Entity[], meta: {...} }
  const items = searchFootballEntitiesData?.items || [];

  return {
    searchFootballEntitiesData: items,
    isSearchFootballEntitiesLoading,
    isSearchFootballEntitiesError,
  };
};
